import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import { potentialTransfer } from '@/api/yuntuSales/customerCenter'
import type { PotentialItem } from '@/typings/api/customerCenter'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'transferModel' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t } = useI18n()

const data = ref<PotentialItem[]>([])
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const editForm = ref<any>({})
const emit = __emit
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { remark, seller, cosIdList } = editForm.value
    potentialTransfer({
      remark,
      cosIdList,
      seller
    })
      .then(() => {
        message.success('转移成功')
        emit('success')
        visible.value = false
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const toggle = (rows: PotentialItem[]) => {
  if (!rows || !rows.length) {
    message.warning('请选择数据')
    return
  }
  data.value = rows
  const cosIdList = rows.map((item) => item.cosId)
  editForm.value = {
    cosIdList
  }
  visible.value = true
}

__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_user_select = _resolveComponent("user-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    title: "转移客户",
    width: "670px",
    onOk: handleSubmit,
    confirmLoading: loading.value,
    okText: _unref(t)('btn.confirm')
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: editForm.value,
            ref_key: "formRef",
            ref: formRef
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "seller",
                label: "选择接收人",
                rules: [{ required: true, message: '请选择' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_user_select, {
                    value: editForm.value.seller,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.seller) = $event)),
                    status: 1
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "type",
                label: "备注"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CosTextarea, {
                    placeholder: "请输入",
                    value: editForm.value.remark,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.remark) = $event)),
                    maxlength: 2000
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "confirmLoading", "okText"]))
}
}

})